import { render, staticRenderFns } from "./ordonnance.vue?vue&type=template&id=34df52bf&"
import script from "./ordonnance.vue?vue&type=script&lang=js&"
export * from "./ordonnance.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports